module.exports = __webpack_public_path__ + "img/Icon-kefu.c6d2a53a.svg";